import React, { Suspense, useEffect, useRef, useState } from 'react';

const FeedbacksSlider = React.lazy(() => import('./feedbacksSlider').then((module) => ({ default: module.FeedbacksSlider })));

export const LazyFeedbacksSlider: React.FC = () => {
  const [shouldLoad, setShouldLoad] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '100px',
      },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      {shouldLoad ? (
        <Suspense fallback={null}>
          <FeedbacksSlider />
        </Suspense>
      ) : null}
    </div>
  );
};
